import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'

@InputType()
export class RenderChatTemplateArgs extends ActionArgs {
  // Exactly one of chatId and orderId; orderId renders for an order that has no conversation yet.
  @Field(() => ID, { nullable: true })
  chatId?: string

  @Field(() => ID, { nullable: true })
  orderId?: string

  @Field(() => ID)
  templateId: string
}

export interface IRenderChatTemplate extends IAction<string, RenderChatTemplateArgs> {}
